import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ro from './locales/ro.json';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ro';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ro: { translation: ro } },
  lng: localStorage.getItem('language') || 'ro',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

dayjs.locale(i18n.language);

export default i18n;
